import {
  ControlledPopover,
  type ControlledPopoverProps,
} from "@stenajs-webui/tooltip";
import type { FC } from "react";

import { getPortalRoot } from "../../use-cases/manage/grid/utils/getPortalRoot";

const portalRoot = getPortalRoot();

interface FreightPortalControlledPopoverProps extends Omit<
  ControlledPopoverProps,
  "disablePadding"
> {
  enablePadding?: boolean;
}

export const FreightPortalControlledPopover: FC<
  FreightPortalControlledPopoverProps
> = ({ enablePadding = false, appendTo, ...props }) => (
  <ControlledPopover
    hideArrow={true}
    {...props}
    disablePadding={!enablePadding}
    appendTo={appendTo ?? portalRoot}
  />
);
